import styled from 'styled-components';

export enum BREAKPOINT_SIZE {
  xxs = 0,
  xs = 320,
  sm = 576,
  md = 768,
  lg = 992,
  xl = 1200
}

export const COLORS = {
  blue: '#0c0b61',
  green: '#95ff7a',
  darkGreen: '#28ab26',
  lightGrey: '#f9f9f9',
  mediumGrey: '#dddddd',
  grey: '#f2f2f2',
  darkGrey: '#727272',
  black: '#000',
  white: '#fff',
  teal: '#2faba8',
  pink: '#cd7c6d'
};

export const MARGIN = {
  small: '16px',
  large: '32px'
};

export const SectionHeading = styled.span`
  font: normal 900 18px/1.2 Avenir-Heavy, sans-serif;
  margin: 0 20px 5px 0;
  color: black;
`;

export const SectionParagraph = styled.span`
  font: normal 500 14px/18px avenir-Medium, sans-serif;
  margin: 0;
`;

export const Strong = styled.span`
  font-weight: bold;
`;
